<div class="modal-header">
  <h3 class="mb-0">{{ isEdit ? 'Edit vendor rank' : 'Add vendor rank' }}</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  <form [formGroup]="companyServiceRankingForm">
    <div class="row g-3">
      <div class="col-md-6">
        <div class="form-group mb-0">
          <label for="rank" class="form-label">Rank</label>
          <input
            id="rank"
            type="text"
            class="form-control"
            formControlName="rank"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group mb-0">
          <label for="priority" class="form-label">Priority</label>
          <select
            id="priority"
            class="form-select"
            formControlName="priorityLevel"
          >
            <option [ngValue]="null" disabled>Pick one...</option>
            @for (priority of priorities; track priority) {
              <option [ngValue]="priority">{{ priority }}</option>
            }
          </select>
        </div>
      </div>
    </div>

    <div class="ranking-scope">
      <div class="check-group mt-0">
        <input
          id="isTradeCategorySpecific"
          type="checkbox"
          class="form-check-input"
          (change)="onTradeOrTradeCategoryChange('isTradeCategorySpecific')"
          formControlName="isTradeCategorySpecific"
        />
        <label for="isTradeCategorySpecific" class="form-check-label mt-0">
          Specific to a trade category
        </label>
      </div>

      <div class="ranking-scope__divider">
        <span class="ranking-scope__divider-text">OR</span>
      </div>

      <div class="check-group mt-0">
        <input
          id="isTradeSpecific"
          type="checkbox"
          class="form-check-input"
          (change)="onTradeOrTradeCategoryChange('isTradeSpecific')"
          formControlName="isTradeSpecific"
        />
        <label for="isTradeSpecific" class="form-check-label mt-0">
          Specific to a trade
        </label>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="save()">Save</button>
  </div>
</div>
